module.exports = __webpack_public_path__ + "img/product_131.d7c2f91.webp";